<template>

    <div class="container">
        <div class="aboutmain">
            <div class="row">
                <div class="col-md-12">
                    <h2><b>Pant</b> Collection's</h2>
                    <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="0">
                    <!-- Carousel indicators -->  
                    <!-- Wrapper for carousel items -->
                    <div class="carousel-inner">
                        <div class="item active">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-1.jpg" class="img-responsive" alt="">									
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Dark Black</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1800.00</strike> <b>৳1299.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-2.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Dark Brown</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1800.00</strike> <b>৳1200.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>		
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-3.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Aqua</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1850.00</strike> <b>৳1350.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>								
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-4.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Mat Black </h4>							
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1900.00</strike> <b>৳1300.99</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-5.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Navy Blue</h4>
                                            <p class="item-price"><strike>৳1850.00</strike> <span>৳1450.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-6.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Sienna</h4>
                                            <p class="item-price"><strike>৳1550.99</strike> <span>৳1199.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-7.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Yellow</h4>
                                            <p class="item-price"><strike>৳1800.00</strike> <span>৳1200.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/pant-8.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Primium Pant Sky Blue</h4>
                                            <p class="item-price"><strike>৳1950.00</strike> <span>৳1470.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>						
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</template>

<script>
    export default {
        name: 'PantCompo'
    }
</script>

<style scoped>
    .col-sm-3{
        text-align: center;
        margin: 20px auto;
    }
    .thumb-wrapper{
        margin: 0 auto;
        width: 80%;
        box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.2), 0 6px 20px 0 rgba(220, 220, 220, 0.19);
        border-radius: 10px;
    }
    img{
        width: 220px;
    }
    a{
        margin: 20px auto;
    }
    h4{
        font-size: 16px;
    }
    .btn:hover{
        opacity: 0.7;
        transition: all 0.2s ease-in-out;
    }
</style>